import Cookies from 'js-cookie';

$(document).on('ready', function(){
    var cataloguesFormId = $('.catalogues-form__data form').attr('data-cf-form');
    var cookieName = $('.form__content').attr('data-form-access');
    if (typeof cataloguesFormId !== 'undefined') {
        var cataloguesForm = document.querySelector('[data-cf-form ="' + cataloguesFormId + '"]');
    }

    if (typeof cataloguesForm !== 'undefined') {
        var cataloguesPageUrl = $('.form__content').attr('data-form-redirect');
        if (cataloguesPageUrl) {
            var cataloguesCookie = Cookies.get(cookieName);
            if (cataloguesCookie == 'true') {
                location.assign(cataloguesPageUrl);
            }
        }

        cataloguesForm.addEventListener('cf:form_submitted', function(event) {
            Cookies.set(cookieName, 'true', { expires: 7 });
            if (cataloguesPageUrl) {
                location.assign(cataloguesPageUrl);
            }
        });

        cataloguesForm.addEventListener('cf:form_submission_failed', function(event) {
            var errors = event.detail.errors;

            if(errors.hasOwnProperty('email')){
                if (errors.email.includes('has already been taken')) {
                    Cookies.set(cookieName, 'true', { expires: 7 });
                    if (cataloguesPageUrl) {
                        location.assign(cataloguesPageUrl);
                    }
                }
            }

            if(errors.hasOwnProperty('phone')){
                if (errors.phone.includes('has already been taken')) {
                    Cookies.set(cookieName, 'true', { expires: 7 });
                    if (cataloguesPageUrl) {
                        location.assign(cataloguesPageUrl);
                    }
                }
            }

        });
    }
});
